import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'Graphic Design & Video Editing Services | RojrzTech',
    description:
      'RojrzTech delivers stunning graphic design and professional video editing — brand identity, logo design, motion graphics, social media visuals, and promotional videos.',
  },
  hero: {
    badge: 'DESIGN & VIDEO EXPERTS',
    slides: [
      {
        heading: { pre: 'Stunning Designs That', gold: 'Tell Your Story' },
        subheading:
          'As your go-to graphic design agency, we ensure every pixel serves a purpose. From brand identity to marketing materials, we create visuals that captivate.',
        pills: ['Branding', 'Logo Design', 'Social Media', 'Print', 'Motion'],
        image: '/graphic.jpeg',
      },
      {
        heading: { pre: 'Video Content That', gold: 'Captivates & Converts' },
        subheading:
          'Professional video editing and production services that turn raw footage into compelling stories. From corporate videos to social media reels.',
        pills: ['Video Editing', 'Reels', 'Animation', 'Explainers', 'Corporate'],
        image: '/video.jpeg',
      },
      {
        heading: { pre: 'Every Pixel', gold: 'Serves a Purpose' },
        subheading:
          'Our design philosophy centers on creating visuals that not only look beautiful but also communicate your brand message clearly and effectively.',
        pills: ['UI Design', 'Illustrations', 'Infographics', 'Icons', 'Banners'],
        image: '/graphic.jpeg',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive Graphic Design & Video Editing Services',
    subtitle:
      'We are a full-service design and video production agency, creating compelling visual content that elevates your brand and engages your audience.',
    cards: [
      {
        icon: '🎨',
        title: 'Brand Identity & Logo Design',
        description:
          'We craft complete brand identities — logos, color palettes, typography, and brand guidelines that make your business unforgettable.',
      },
      {
        icon: '📱',
        title: 'Social Media Graphics',
        description:
          'Eye-catching social media visuals, templates, and campaigns designed to stop the scroll and drive maximum engagement.',
      },
      {
        icon: '🎬',
        title: 'Video Editing & Production',
        description:
          'Professional video editing that transforms raw footage into polished, compelling content — from corporate videos to social media reels.',
      },
      {
        icon: '✨',
        title: 'Motion Graphics & Animation',
        description:
          'Dynamic motion graphics and 2D animations that bring your brand to life and communicate complex ideas in an engaging, memorable way.',
      },
      {
        icon: '🖨️',
        title: 'Print & Marketing Materials',
        description:
          'From business cards to brochures, banners to packaging — we design print materials that leave a lasting professional impression.',
      },
      {
        icon: '📊',
        title: 'Infographics & Presentations',
        description:
          'Transform complex data and ideas into visually stunning infographics and presentations that communicate clearly and persuasively.',
      },
    ],
  },
  features: {
    title: 'Graphic Design & Video Services for Accelerated Business Growth',
    subtitle:
      'Create compelling visual content that enhances your brand reputation, elevates your presence, and expands your audience reach.',
    items: [
      'Brand Identity',
      'Logo Design',
      'Social Media Kits',
      'Video Editing',
      'Motion Graphics',
      '2D Animation',
      'Explainer Videos',
      'Ad Creatives',
      'Infographics',
      'Pitch Decks',
      'Print Design',
      'UI Illustrations',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best design outcomes for our clients. We refine every design until you're completely satisfied.",
    cards: [
      {
        icon: '🎯',
        title: 'Strategic Visual Storytelling',
        description:
          'Every design we create tells a story. We align visuals with your brand strategy to communicate your message with maximum impact.',
      },
      {
        icon: '⚡',
        title: 'Fast Turnaround Times',
        description:
          'We understand deadlines matter. Our streamlined design process ensures quick delivery without sacrificing quality or creativity.',
      },
      {
        icon: '🔄',
        title: 'Unlimited Revisions',
        description:
          'We work until you\'re 100% satisfied. Our revision policy ensures you get exactly the design you envisioned for your brand.',
      },
      {
        icon: '📁',
        title: 'All File Formats Provided',
        description:
          'You receive all source files and exports in every format you need — print-ready, web-optimized, and everything in between.',
      },
      {
        icon: '🌟',
        title: 'Award-Worthy Quality',
        description:
          'Our designers bring years of experience and a passion for excellence, producing work that stands out in today\'s crowded market.',
      },
      {
        icon: '🤝',
        title: 'Dedicated Creative Team',
        description:
          'You work with a dedicated team who understand your brand inside and out, delivering consistent quality across every project.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/graphic-design'),
};

const GraphicDesign = () => <ServicePageTemplate pageData={pageData} />;
export default GraphicDesign;
